import React, { useState, useEffect } from 'react';

export default function NumberStepper({ value, onChange, label, step = 1, min = 0, max = 999 }) {
  const [val, setVal] = useState(value || 0);

  useEffect(() => { setVal(value || 0); }, [value]);

  const update = (newVal) => {
    const clamped = Math.max(min, Math.min(max, newVal));
    setVal(clamped);
    onChange(clamped);
  };

  return (
    <div className="flex flex-col items-center gap-0.5 flex-1 min-w-0">
      {label && <span className="text-data text-[9px] text-neutral-400">{label}</span>}
      <div className="flex items-center w-full rounded-xl overflow-hidden">
        <button
          onClick={() => update(val - step)}
          className="h-12 sm:h-14 flex-1 flex items-center justify-center glass-elevated text-white text-xl font-black active:scale-90 select-none"
          data-testid={`stepper-${label}-minus`}
        >
          -
        </button>
        <div
          className="h-12 sm:h-14 flex-[1.5] flex items-center justify-center glass text-metric text-lg sm:text-xl text-white"
          data-testid={`stepper-${label}-value`}
        >
          {val || 0}
        </div>
        <button
          onClick={() => update(val + step)}
          className="h-12 sm:h-14 flex-1 flex items-center justify-center glass-elevated text-white text-xl font-black active:scale-90 select-none"
          data-testid={`stepper-${label}-plus`}
        >
          +
        </button>
      </div>
    </div>
  );
}
